module.exports = __webpack_public_path__ + "IX COLOMBIA.png?91f2a6c01873850f025dcc87f88123c2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global/img/IX COLOMBIA.png
// module id = 22
// module chunks = 0